<template>
    <div class="wrapper wrapper5">
        <ul>
            <li v-for="item in NEWS.slice(0, 6)" :key="item.id">
                <router-link :to="`/detail/${item.id}`">
                    <strong>{{ item.title }}</strong>
                </router-link>
            </li>
        </ul>
        <ul>
            <li v-for="item in NEWS.slice(6)" :key="item.id">
                <router-link :to="`/detail/${item.id}`">
                    <strong>{{ item.title }}</strong>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref } from "vue";
import NEWS from "@/config/news";
</script>

<style lang="scss" scoped>
.wrapper5 {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/6.jpg");
    height: 960px;
    padding-top: 240px;
    ul {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
        li {
            width: 173px;
            height: 181px;
            position: relative;
            margin: 16px 16px;
            a {
                position: absolute;
                width: 100%;
                height: 100%;
                background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/link-icon.png");
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                background-position: 0px 0px;
                color: #703607;
                font-size: 22px;
                font-weight: bold;
                font-style: italic;
                line-height: 1.2;
                strong {
                    width: 90px;
                }
                &:hover {
                    background-position: -233px 0px;
                }
            }
        }
    }
}
</style>
